import { useMemo } from 'react';

interface UseChatInputValidationOptions {
	prompt: string;
	attachments: any[] | undefined;
	loadingAttachments: any[] | undefined;
}

interface UseChatInputValidationResult {
	canSubmit: boolean;
	hasLoadingAttachments: boolean;
	minimalInputEntered: boolean;
}

export function useChatInputValidation({
	prompt,
	attachments,
	loadingAttachments,
}: UseChatInputValidationOptions): UseChatInputValidationResult {
	const hasLoadingAttachments = useMemo(
		() => !!(loadingAttachments && loadingAttachments.length > 0),
		[loadingAttachments]
	);

	const minimalInputEntered = useMemo(
		() => prompt.length > 0 || !!(attachments && attachments.length > 0),
		[prompt, attachments]
	);

	const canSubmit = minimalInputEntered && !hasLoadingAttachments;

	return {
		canSubmit,
		hasLoadingAttachments,
		minimalInputEntered,
	};
}
